module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAARZJREFUOE+9U81Kw0AYnNnk4CMITUHfwKMXoX2DHi3JxYB47gN48gF6lkK8JNSjb9CCF4++gUJT6CN4SHZkY4X4Fwmk3dOw8+18M9/uEh0tdqSD7oWSqHcF8Py7Q1mkbo8G0U/3uo/T9W3Ff5JJFCwADtpF1TJO8+FuhSQ7seSz6+KBcwCHW5ebEho7bKQT0kyBZkcbCG/ugKCApF9hqSCYV6LEwUeDBiFry7Fn7ZOrt77/SDDYiuamKM4cLo05Ncab78dRCQ0v03zpOidh/wXEURVHeI2z1bGDsygYeODiP0ctXsAur/8u7E8FjOp2RPn1YVMs6jyBh4tsNfnyIP/Kk4S9G8fF2fq6KXP3n7bFhH8t7czROzspjBP1kCTHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SearchPage/book.png
// module id = k0sj
// module chunks = 1